import { ApiResult } from 'interfaces/APITypes';
import { TranslationResponse } from 'interfaces/TranslationTypes';

import { makeRequest, mytoverInstance } from './client';

export const updateTranslations = async (payload: FormData): Promise<ApiResult<TranslationResponse>> => {
  return makeRequest(mytoverInstance.post('/tover/translations', payload));
};
